var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLinkedin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M14.5,11.5 C13.395,11.5 12.5,12.396 12.5,13.5 L12.5,20.5 L7.5,20.5 C7.5,20.5 7.559,8.5 7.5,7.5 L12.5,7.5 L12.5,8.985 C12.5,8.985 14.048,7.542 16.439,7.542 C19.4,7.542 21.5,9.685 21.5,13.846 L21.5,20.5 L16.5,20.5 L16.5,13.5 C16.5,12.396 15.605,11.5 14.5,11.5 L14.5,11.5 Z M2.99,5.5 L2.961,5.5 C1.45,5.5 0.473,4.318 0.473,3.019 C0.473,1.69 1.48,0.607 3.02,0.607 C4.561,0.607 5.508,1.725 5.538,3.054 C5.538,4.354 4.561,5.5 2.99,5.5 L2.99,5.5 Z M5.5,20.5 L0.5,20.5 L0.5,7.5 L5.5,7.5 L5.5,20.5 Z",
    transform: "translate(1)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/linkedin.12728b8e.svg";
export { ForwardRef as ReactComponent };